import { generateEmailCallToActionButton, generateEmailParagraph, generateEmailText } from "../../generateEmailParagraph"

export const generateButtonPdfVoucherLink = (downloadPdfVoucherUrl?: string): string =>
  downloadPdfVoucherUrl
    ? `
        ${generateEmailText(`<strong>Dárkového poukaz:</strong>`)}
        ${generateEmailParagraph(`Při registraci bylo vybráno zaslání dárkového poukazu. Zde je ke stažení PDF soubor s vaším poukazem.`)}
        
        ${generateEmailCallToActionButton(
          "Klikutím otevřete stránku ke stažení PDF souboru",
          "Stáhnout PDF",
          `${downloadPdfVoucherUrl}?utm_source=download_pdf_voucher_link&utm_medium=email&utm_campaign=download_pdf_voucher_link`
        )}
`
    : ""
